import { useEffect, useState } from 'react';
import { Box, Theme, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector, intermitenceSelector, memorySelector, storySelector } from '@/store/selectors';
import { MemoriesForm } from './components';
import { UseFirstRender } from '@/hooks';
import { useRouter } from 'next/router';
import { actualStory, createMemoryViewG, getMemories, showActualSection } from '@/store/actions';
import Image from 'next/image';
import { cdn_url } from '@/utils';
import { ErrorPopup } from '@/components/ErrorPopup';

export const CreateMemory = () => {
  const dispatch = useDispatch();
  const createData = useSelector(memorySelector);
  const { story } = useSelector(storySelector);
  const { separation } = useSelector(intermitenceSelector);
  const { user } = useSelector(authSelector);
  const { createMemoryStep } = createData;
  const router = useRouter();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [mainStep, SetMainStep] = useState(1);

  const showScreen = () => {
    switch (createMemoryStep) {
      default:
        return <MemoriesForm SetMainStep={SetMainStep} />;
    }
  };

  UseFirstRender(() => {
    if (!story?.id) dispatch(actualStory(router.query?.id as string));
  }, [router?.query?.id]);

  UseFirstRender(() => {
    if (user) dispatch(createMemoryViewG(user?.id));
  }, [dispatch]);

  UseFirstRender(() => {
    if (story?.id) {
      dispatch(showActualSection(story?.title));
      dispatch(getMemories(story?.id));
    }
  }, [story]);

  const useBodyBackground = (color: string = '#fff') => {
    useEffect(() => {
      document.body.style.background = color;

      return () => {
        document.body.style.background = '';
      };
    }, [color]);
  };
  useBodyBackground('rgba(33, 45, 109, 1)');

  return (
    <Box
      display='flex'
      flexDirection='column'
      width='100%'
      height='100vh'
      position='relative'
      sx={{
        width: '100%',
        height: '100vh',
        position: 'relative',
        overflow: 'hidden',
        backgroundImage: !isMobile ? 'url(/images/bg-main.jpg)' : 'url(/images/bg-main.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'bottom center',
      }}>
      {isMobile && (
        <Image
          priority
          src={`${cdn_url}${story.cover_image}`}
          fill={true}
          alt='hello'
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,

            transition: 'opacity 0.2s ease-in-out',
          }}
        />
      )}
      {/* Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100vh',
          backdropFilter: 'blur(40px)',
          zIndex: 0,
        }}
      />
      <Box
        display={'flex'}
        // paddingBottom={'1rem'}
        width={'100%'}
        justifyContent={'space-between'}
        flexDirection={'column'}
        height={isMobile ? '100dvh' : '100%'}
        alignItems={'center'}
  sx={{
    overflowY: 'auto',
    scrollBehavior: 'smooth',           
    WebkitOverflowScrolling: 'touch',    
  }}
  >

        {showScreen()}
      </Box>
      <ErrorPopup/>
    </Box>
  );
};
